import { settings } from '@springtree/eva-sdk-core-settings';
import { SETTINGS_GROUP_NAME, getServiceSettings, setServiceSetting } from '@springtree/eva-sdk-core-service';
import { atom } from 'recoil';
import storage from '../../helpers/storage.js';
import { storageKey as endpointStorageKey } from './eva-endpoint-url-state.js';
import { logger } from '@springtree/eva-sdk-core-logger';
export const storageKey = 'evaApplicationToken';
// This atom is used to persist and restore the most recent application token
// so it persists between app reload/restarts
//
const applicationTokenState = atom({
    key: 'evaApplicationToken',
    default: storage.getItem(storageKey) || '',
    effects: [
        ({ setSelf, onSet }) => {
            // Set initial value from storage
            //
            const storedApplicationToken = storage.getItem(storageKey);
            setSelf(storedApplicationToken || '');
            // Supply the stored application token to the @springtree/eva-sdk-core-service in-memory cache
            //
            const storedEndpointUrl = storage.getItem('evaEndpointUrl');
            if (storedEndpointUrl && storedApplicationToken) {
                const requestUrl = new URL(storedEndpointUrl);
                const origin = requestUrl.origin;
                const applicationTokens = getServiceSettings().applicationTokens ?? {};
                applicationTokens[origin] = storedApplicationToken;
                setServiceSetting('applicationTokens', applicationTokens);
            }
            // Update storage on change
            //
            onSet((newValue, oldValue, isReset) => {
                if (newValue !== oldValue) {
                    isReset || !newValue
                        ? storage.removeItem(storageKey)
                        : storage.setItem(storageKey, newValue);
                }
            });
            // Listen for updates applied through local storage
            // Not that storage events are only triggered from other tabs/windows
            // If you update the storage in the active window itself there will be no trigger
            //
            if (globalThis.addEventListener) {
                globalThis.addEventListener('storage', (storageEvent) => {
                    /* istanbul ignore next */
                    switch (storageEvent.key) {
                        case storageKey:
                            {
                                logger.debug('[STATE:applicationTokenState] Storage event', storageEvent);
                                if (storageEvent.newValue !== storageEvent.oldValue) {
                                    setSelf(storageEvent.newValue ? storageEvent.newValue : '');
                                }
                            }
                            break;
                        case endpointStorageKey:
                            {
                                // Changes to the endpoint warrant this atom being unset
                                // or to whatever the @springtree/eva-sdk-core-service setting
                                // says for the new endpoint
                                //
                                logger.debug('[STATE:applicationTokenState] Endpoint changed', storageEvent);
                                if (storageEvent.newValue !== storageEvent.oldValue) {
                                    if (storageEvent.newValue) {
                                        const newEndpointUrl = new URL(storageEvent.newValue);
                                        const origin = newEndpointUrl.origin;
                                        const applicationTokens = getServiceSettings().applicationTokens ?? {};
                                        const newApplicationToken = applicationTokens[origin];
                                        setSelf(newApplicationToken);
                                        storage.setItem(storageKey, newApplicationToken || '');
                                    }
                                    else {
                                        setSelf('');
                                        storage.removeItem(storageKey);
                                    }
                                }
                            }
                            break;
                        default:
                            {
                                // NOOP
                            }
                            break;
                    }
                });
            }
            // Listen for updates coming from the @springtree/eva-sdk-core-service
            //
            settings.subscribe({
                channel: `eva.setting.${SETTINGS_GROUP_NAME}.applicationTokens`,
                callback: ({ value }) => {
                    const currentEndpointUrl = storage.getItem(endpointStorageKey);
                    if (currentEndpointUrl) {
                        const requestUrl = new URL(currentEndpointUrl);
                        const origin = requestUrl.origin;
                        const applicationTokens = value.new || {};
                        const newApplicationToken = applicationTokens[origin];
                        storage.setItem(storageKey, newApplicationToken || '');
                        setSelf(newApplicationToken || '');
                    }
                },
            });
        },
    ],
});
export default applicationTokenState;
//# sourceMappingURL=application-token-state.js.map